import React, { useEffect, useState } from 'react';
import {
    Container, Typography, Box, CircularProgress,
    Alert, Grid, Card, CardMedia, Divider, Chip
} from '@mui/material';
import { Info, WorkspacePremium } from '@mui/icons-material';
import NavbarMain from '../components/NavbarMain';
import axios from 'axios';
import Footer from "../components/Footer";
import SEO from '../components/SEO'; // ✅ ДОДАДЕНО

const AboutPage = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchAbout();
    }, []);

    const fetchAbout = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/public/about-us`);
            setData(res.data);
            setError('');
        } catch (err) {
            console.error('Error loading about us:', err);
            setError('Грешка при вчитување. Обидете се повторно.');
        } finally {
            setLoading(false);
        }
    };

    const resolveImageUrl = (url) => {
        if (!url) return '';
        return url.startsWith('http') ? url : `${process.env.REACT_APP_API_URL}${url}`;
    };

    if (loading) {
        return (
            <>
                <NavbarMain />
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh"
                     sx={{ background: 'linear-gradient(135deg, #ffeef8 0%, #e0f7ff 100%)' }}>
                    <CircularProgress size={60} sx={{ color: '#ff7eb9' }} />
                </Box>
            </>
        );
    }

    return (
        <>
            {/* ✅ SEO */}
            <SEO
                title="За Нас - BodyLab by Anamarija"
                description="Дознај повеќе за BodyLab by Anamarija - мисијата, визијата и приказната зад најдобрите персонализирани фитнес програми и диети за жени во Македонија."
                url="/about"
            />

            <NavbarMain />

            <Box sx={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #ffeef8 0%, #e0f7ff 100%)',
                pt: 12, pb: 10
            }}>
                <Container maxWidth="lg">

                    {/* ===== HEADER ===== */}
                    <Box textAlign="center" mb={8}>
                        <Box sx={{
                            width: 72, height: 72, borderRadius: '50%', mx: 'auto', mb: 3,
                            background: 'linear-gradient(135deg, #ff7eb9, #AB47BC)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            boxShadow: '0 8px 32px rgba(255,126,185,0.35)'
                        }}>
                            <Info sx={{ fontSize: 40, color: 'white' }} />
                        </Box>

                        {/* ✅ H1 */}
                        <Typography variant="h1" sx={{
                            fontWeight: 900,
                            background: 'linear-gradient(45deg, #ff7eb9, #AB47BC)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            mb: 1.5,
                            fontSize: { xs: '2.2rem', md: '3rem' }
                        }}>
                            За Нас 🏋️‍♂️
                        </Typography>

                        {/* ✅ H2 */}
                        <Typography variant="h2" sx={{
                            color: '#888', fontWeight: 400,
                            maxWidth: 600, mx: 'auto',
                            fontSize: { xs: '1rem', md: '1.25rem' }
                        }}>
                            Запознајте се со нашата приказна и мисија
                        </Typography>

                        <Box sx={{
                            width: 60, height: 4, borderRadius: 2,
                            background: 'linear-gradient(90deg, #ff7eb9, #AB47BC)',
                            mx: 'auto', mt: 2
                        }} />
                    </Box>

                    {/* ===== ERROR ===== */}
                    {error && (
                        <Alert severity="error" sx={{ mb: 4, borderRadius: 2, maxWidth: 600, mx: 'auto' }}>
                            {error}
                        </Alert>
                    )}

                    {/* ===== CONTENT ===== */}
                    {data && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>

                            {/* BodyLab Card */}
                            <Card sx={{
                                borderRadius: '20px', backgroundColor: '#ffffff',
                                border: '1px solid rgba(165,216,255,0.3)',
                                boxShadow: '0 4px 24px rgba(165,216,255,0.1)',
                                overflow: 'hidden', transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'translateY(-4px)',
                                    boxShadow: '0 12px 40px rgba(165,216,255,0.2)',
                                    borderColor: 'rgba(165,216,255,0.5)'
                                }
                            }}>
                                <Box sx={{ height: 5, background: 'linear-gradient(90deg, #a5d8ff, #ff7eb9)' }} />
                                <Box sx={{ p: { xs: 3, md: 5 } }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                                        <Chip label="BodyLab" size="small" sx={{
                                            bgcolor: 'rgba(165,216,255,0.15)', color: '#4a9edd',
                                            fontWeight: 'bold', border: '1px solid rgba(165,216,255,0.4)'
                                        }} />
                                    </Box>

                                    {/* ✅ H3 */}
                                    <Typography variant="h3" sx={{
                                        color: '#ff7eb9', fontWeight: 800, mb: 3,
                                        fontSize: { xs: '1.6rem', md: '2.2rem' }
                                    }}>
                                        {data.bodyLabTitle || 'BodyLab by Anamarija'}
                                    </Typography>

                                    <Divider sx={{ mb: 3, borderColor: 'rgba(165,216,255,0.2)' }} />

                                    <Typography variant="body1" sx={{
                                        lineHeight: 2, fontSize: '1.1rem',
                                        color: '#444', whiteSpace: 'pre-wrap'
                                    }}>
                                        {data.bodyLabText}
                                    </Typography>
                                </Box>
                            </Card>

                            {/* Biography Card */}
                            <Card sx={{
                                borderRadius: '20px', backgroundColor: '#ffffff',
                                border: '1px solid rgba(255,126,185,0.2)',
                                boxShadow: '0 4px 24px rgba(255,126,185,0.08)',
                                overflow: 'hidden', transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'translateY(-4px)',
                                    boxShadow: '0 12px 40px rgba(255,126,185,0.18)',
                                    borderColor: 'rgba(255,126,185,0.35)'
                                }
                            }}>
                                <Box sx={{ height: 5, background: 'linear-gradient(90deg, #ff7eb9, #AB47BC)' }} />
                                <Box sx={{ p: { xs: 3, md: 5 } }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                                        <Chip label="Биографија" size="small" sx={{
                                            bgcolor: 'rgba(255,126,185,0.1)', color: '#ff7eb9',
                                            fontWeight: 'bold', border: '1px solid rgba(255,126,185,0.3)'
                                        }} />
                                    </Box>

                                    {/* ✅ H3 */}
                                    <Typography variant="h3" sx={{
                                        color: '#ff7eb9', fontWeight: 800, mb: 3,
                                        fontSize: { xs: '1.6rem', md: '2.2rem' }
                                    }}>
                                        {data.biographyTitle || 'Биографија'}
                                    </Typography>

                                    <Divider sx={{ mb: 3, borderColor: 'rgba(255,126,185,0.15)' }} />

                                    <Typography variant="body1" sx={{
                                        lineHeight: 2, fontSize: '1.1rem',
                                        color: '#444', whiteSpace: 'pre-wrap'
                                    }}>
                                        {data.biographyText}
                                    </Typography>
                                </Box>
                            </Card>

                            {/* Diplomas Section */}
                            {data.diplomas && data.diplomas.length > 0 && (
                                <Box>
                                    <Box textAlign="center" mb={5} mt={2}>
                                        <Box sx={{
                                            width: 64, height: 64, borderRadius: '50%', mx: 'auto', mb: 2,
                                            background: 'linear-gradient(135deg, #ffd166, #ff7eb9)',
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            boxShadow: '0 8px 24px rgba(255,209,102,0.35)'
                                        }}>
                                            <WorkspacePremium sx={{ fontSize: 34, color: 'white' }} />
                                        </Box>

                                        {/* ✅ H3 */}
                                        <Typography variant="h3" sx={{
                                            fontWeight: 900,
                                            background: 'linear-gradient(45deg, #ff7eb9, #AB47BC)',
                                            WebkitBackgroundClip: 'text',
                                            WebkitTextFillColor: 'transparent',
                                            mb: 1, fontSize: { xs: '1.8rem', md: '2.4rem' }
                                        }}>
                                            Дипломи и Сертификати 🏆
                                        </Typography>

                                        <Box sx={{
                                            width: 50, height: 4, borderRadius: 2,
                                            background: 'linear-gradient(90deg, #ffd166, #ff7eb9)',
                                            mx: 'auto', mt: 1.5
                                        }} />
                                    </Box>

                                    <Grid container spacing={3}>
                                        {data.diplomas.map((diploma, index) => (
                                            <Grid item xs={12} sm={6} md={4} key={diploma.id}>
                                                <Card sx={{
                                                    borderRadius: '16px', overflow: 'hidden',
                                                    backgroundColor: '#ffffff',
                                                    border: '1px solid rgba(255,126,185,0.2)',
                                                    boxShadow: '0 4px 20px rgba(255,126,185,0.08)',
                                                    transition: 'all 0.3s ease',
                                                    '&:hover': {
                                                        transform: 'translateY(-6px) scale(1.02)',
                                                        boxShadow: '0 16px 40px rgba(255,126,185,0.22)',
                                                        borderColor: 'rgba(255,126,185,0.4)'
                                                    }
                                                }}>
                                                    <Box sx={{
                                                        height: 4,
                                                        background: index % 3 === 0
                                                            ? 'linear-gradient(90deg, #ff7eb9, #AB47BC)'
                                                            : index % 3 === 1
                                                                ? 'linear-gradient(90deg, #ffd166, #ff7eb9)'
                                                                : 'linear-gradient(90deg, #a5d8ff, #ff7eb9)'
                                                    }} />
                                                    <CardMedia
                                                        component="img"
                                                        height="280"
                                                        image={resolveImageUrl(diploma.imageUrl)}
                                                        alt={diploma.fileName}
                                                        sx={{ objectFit: 'cover' }}
                                                    />
                                                </Card>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Box>
                            )}
                        </Box>
                    )}
                </Container>
            </Box>
            <Footer />
        </>
    );
};

export default AboutPage;